(ns yardwerkz.web.booking.review
  "Step 7: Review all selections and submit the job."
  (:require
   [uix.core :refer [defui $ use-state]]
   [io.factorhouse.rfx.core :as rfx]
   [yardwerkz.web.store :as store]
   [yardwerkz.web.router :as router]
   [yardwerkz.web.domain.outline :as outline]
   [yardwerkz.web.ui.components :as ui]
   [yardwerkz.web.ui.icons :as icons]))

(defui review-item [{:keys [icon label value]}]
  ($ :div {:class "flex items-start space-x-3 py-3 border-b border-gray-100 last:border-0"}
     ($ :div {:class "mt-0.5 text-gray-400"} icon)
     ($ :div {:class "flex-1"}
        ($ :p {:class "text-xs text-gray-500"} label)
        ($ :p {:class "text-sm font-medium text-gray-900"} value))))

(defui review-step [{:keys [on-back]}]
  (let [dispatch (rfx/use-dispatch)
        draft (rfx/use-sub [::store/draft-job])
        submitting (rfx/use-sub [::store/job-submitting])
        submit-error (rfx/use-sub [::store/job-submit-error])
        [submitted set-submitted] (use-state false)

        service (:service draft)
        address (:address draft)
        geo (:geo draft)
        details (:details draft)
        schedule (:schedule draft)
        pricing (:pricing draft)]

    (if submitted
      ;; Success state
      ($ :div {:class "text-center py-12"}
         ($ :div {:class "mx-auto w-16 h-16 bg-green-100 rounded-full flex items-center justify-center mb-4"}
            ($ icons/CheckCircle {:size 32 :class "text-green-600"}))
         ($ :h2 {:class "text-xl font-bold text-gray-900 mb-2"} "Job Submitted!")
         ($ :p {:class "text-gray-500 mb-6"} "We'll match you with a pro and send quotes shortly.")
         ($ ui/button {:on-click #(do (dispatch [::store/reset-draft])
                                      (router/navigate! :jobs))}
            "View My Jobs"))

      ;; Review form
      ($ :div {:class "space-y-4"}
         ($ :h2 {:class "text-lg font-semibold text-gray-900"} "Review Your Booking")

         ($ ui/card {:class "p-4 divide-y divide-gray-100"}
            ($ review-item {:icon ($ icons/Shovel {:size 18})
                            :label "Service"
                            :value (or (:name service) "Not selected")})
            ($ review-item {:icon ($ icons/MapPin {:size 18})
                            :label "Address"
                            :value (or (:full-address address) (:address address) "Not selected")})
            ($ review-item {:icon ($ icons/MapIcon {:size 18})
                            :label "Zones"
                            :value (if (seq geo)
                                     (str (count geo) " zone" (when (> (count geo) 1) "s")
                                          " — " (clojure.string/join ", "
                                                                     (map #(or (outline/get-zone-label (:tag %)) "Untagged") geo)))
                                     "Not drawn")})
            ($ review-item {:icon ($ icons/Calendar {:size 18})
                            :label "Schedule"
                            :value (if (and (:date schedule) (:time schedule))
                                     (str (:date schedule) " — " (:time schedule))
                                     "Not selected")})
            ($ review-item {:icon ($ icons/DollarSign {:size 18})
                            :label "Pricing"
                            :value (if pricing
                                     (str (clojure.string/capitalize (or (:tier pricing) ""))
                                          (when (:display-price pricing)
                                            (str " — " (:display-price pricing))))
                                     "Not selected")})
            (when (:has-pets details)
              ($ review-item {:icon ($ icons/Dog {:size 18})
                              :label "Pets"
                              :value "Yes, pets in yard"}))
            (when (and (:terrain details) (not= (:terrain details) "flat"))
              ($ review-item {:icon ($ icons/Mountain {:size 18})
                              :label "Terrain"
                              :value (clojure.string/replace (:terrain details) "-" " ")}))
            (when (seq (:access-instructions details))
              ($ review-item {:icon ($ icons/Lock {:size 18})
                              :label "Access Instructions"
                              :value (:access-instructions details)}))
            (when (seq (:photos details))
              ($ review-item {:icon ($ icons/Camera {:size 18})
                              :label "Photos"
                              :value (str (count (:photos details)) " photo(s) attached")})))

         ;; Error message
         (when submit-error
           ($ :div {:class "p-3 bg-red-50 border border-red-200 rounded-lg text-sm text-red-700"}
              submit-error))

         ;; Submit button
         ($ :div {:class "flex items-center justify-between pt-4"}
            ($ ui/button {:variant :secondary :on-click on-back}
               ($ :span {:class "flex items-center space-x-1"}
                  ($ icons/ChevronLeft {:size 16})
                  ($ :span "Back")))
            ($ ui/button {:loading submitting
                          :on-click (fn []
                                      (dispatch [::store/submit-job
                                                 {:on-success (fn [_job-id]
                                                                (set-submitted true))
                                                  :on-failure (fn [_]
                                                                (ui/show-toast! :error "Submission failed. Please try again."))}]))}
               ($ :span {:class "flex items-center space-x-1"}
                  ($ icons/Check {:size 16})
                  ($ :span "Submit Request"))))))))
